/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { HelloControllerBreakMutationResponse } from "../types/HelloControllerBreak.ts"

export const helloControllerBreakMutationKey = () =>
  [{ url: "/break" }] as const

export type HelloControllerBreakMutationKey = ReturnType<
  typeof helloControllerBreakMutationKey
>

/**
 * {@link /break}
 */
export async function helloControllerBreak(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    HelloControllerBreakMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "POST", url: `/break`, ...requestConfig })
  return res
}

export function helloControllerBreakMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const mutationKey = helloControllerBreakMutationKey()
  return mutationOptions<
    ResponseConfig<HelloControllerBreakMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >({
    mutationKey,
    mutationFn: async () => {
      return helloControllerBreak(config)
    },
  })
}

/**
 * {@link /break}
 */
export function useHelloControllerBreak<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<HelloControllerBreakMutationResponse>,
      ResponseErrorConfig<Error>,
      void,
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? helloControllerBreakMutationKey()

  const baseOptions = helloControllerBreakMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<HelloControllerBreakMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >

  return useMutation<
    ResponseConfig<HelloControllerBreakMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<HelloControllerBreakMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >
}
